// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ij3xw","actions":"style_actions__H2lGK","actions_btn":"style_actions_btn__YMYZE"};